import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { FeatureNoticeService } from '@app/services/feature-notice.service';
import { TabService } from '@app/services/tab.service';
import { ModalService } from '@app/components/modal/modal.service';
import { VehicleSelectionComponent } from '../vehicle-selection.component';
import { TranslocoModule } from '@jsverse/transloco';
import { Button } from 'primeng/button';

@Component({
  selector: 'app-open-vehicle-selection-button',
  standalone: true,
  imports: [CommonModule, TranslocoModule, Button],
  template: `
    @if (type === 'icon') {
      <button
        class="flex items-center justify-center rounded p-3"
        [title]="'chat.createFirstThread.button' | transloco"
        (click)="onButtonClick($event)"
        data-testid="create-thread-button">
        <i class="pi pi-plus-circle" aria-hidden="false"></i>
      </button>
    } @else if (type === 'white-button') {
      <button
        data-testid="create-thread-button"
        class="flex w-full items-center justify-center rounded-md bg-white p-4 text-black"
        (click)="onButtonClick($event)">
        {{ 'chat.createFirstThread.button' | transloco }}
        <i class="pi pi-plus-circle ml-2" aria-hidden="false"></i>
      </button>
    } @else {
      <p-button (onClick)="onButtonClick($event)">{{ 'chat.createFirstThread.button' | transloco }}</p-button>
    }
  `,
})
export class OpenVehicleSelectionButtonComponent implements OnInit {
  @Input() type: 'icon' | 'button' | 'white-button' = 'button';
  @Output() onClick = new EventEmitter<Event>();

  tabService = inject(TabService);
  modalService = inject(ModalService);
  featureNoticeService = inject(FeatureNoticeService);

  ngOnInit(): void {
    this.tabService.registerVehicleSelectionFunction(this.openVehicleSelection.bind(this));
  }

  onButtonClick(event: Event): void {
    this.onClick.emit(event);
    if (this.featureNoticeService.shouldShowNotice()) {
      this.tabService.showFeatureNotice(true, true);
    } else {
      this.openVehicleSelection();
    }
  }

  openVehicleSelection() {
    this.modalService.open(
      VehicleSelectionComponent,
      {},
      { screen: 'auto', class: 'vehicle-selection', closeOnEscape: false, focusOnOpen: '#vinInput' },
    );
  }
}
